import React from 'react';
import { useTaggingConfig } from 'src/ItemTags/api';
import { notStarted } from '@higherlogic/ocfe/src/utils';

export type TaggingConfig = {
    validTagGroupsExist: boolean;
    showTagGroupLabels: boolean;
    userCreatedTagGroupName: string;
};

type TaggingConfigLoadableValue = ReturnType<typeof useTaggingConfig>;

const TaggingContext = React.createContext<TaggingConfigLoadableValue>([notStarted(), () => {}]);
TaggingContext.displayName = 'TaggingContext';
export { TaggingContext };
